export default class DragManager {
    constructor(scene, allowRedrag = false, freeDrag = false){
        this.scene = scene;

        this.allowRedrag = allowRedrag;
        this.freeDrag = freeDrag;

        // Ajout des groups
        this.draggableGroup = this.scene.add.group();
        this.dropZoneGroup = this.scene.add.group();

        // Remove les anciens listener
        this.scene.input.removeListener('dragstart')
        this.scene.input.removeListener('drag')
        this.scene.input.removeListener('drop')
        this.scene.input.removeListener('dragend')
        this.scene.input.removeListener('dragenter')
        this.scene.input.removeListener('dragleave')

        this.dropFunction = ()=> {}

        this.scene.input.on('dragstart', (pointer, gameObject) => {
            this.scene.children.bringToTop(gameObject);
        });

        this.scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
            gameObject.x = dragX;
            gameObject.y = dragY;
            if(gameObject.onDrag){
                gameObject.onDrag()
            }
        });

        this.scene.input.on('drop', (pointer, gameObject, dropZone) => {
            if(gameObject.drop){
                gameObject.drop(pointer, gameObject, dropZone)
            }
            if(dropZone.drop){
                dropZone.drop(pointer, gameObject, dropZone)
            }

            this.drop(pointer, gameObject, dropZone)
            this.scene.input.setDefaultCursor('default')
        });
    
        this.scene.input.on('dragend', (pointer, gameObject, dropped) => {
            this.dragEnd(pointer, gameObject, dropped)
            this.scene.input.setDefaultCursor('default')
        });

        this.scene.input.on('dragenter', (pointer, gameObject, dropZone) => {
            if(dropZone.dragOnPointerOver){
                dropZone.dragOnPointerOver()
            }
            if(gameObject.dragOnPointerOver){
                gameObject.dragOnPointerOver()
            }
        });
        
        this.scene.input.on('dragleave', (pointer, gameObject, dropZone) => {
            if(dropZone.dragOnPointerOut){
                dropZone.dragOnPointerOut()
            }
            if(gameObject.dragOnPointerOut){
                gameObject.dragOnPointerOut()
            }
        });
    }

    // -- Fonctions ajouts draggables & dragzones

    clearDraggables(){
        this.draggableGroup.clear(true, true);
    }

    resetDraggable(draggable){
        if(draggable.resetPosition){
            draggable.resetPosition()
        }
        if(draggable.input){
            draggable.input.enabled = true;
        }
        if(draggable.dropedZone){
            draggable.dropedZone.dropped = undefined;
            draggable.dropedZone = undefined;
        }
        if(draggable.setNormal){
            draggable.setNormal()
        }
    }

    clearDropZones(){
        this.dropZoneGroup.clear(true, true);
    }

    resetDropZones(){
        this.dropZoneGroup.getChildren().forEach(dropZone => {
            if(dropZone.reset){
                dropZone.reset()
            }
        });
    }

    addDraggable(object, id, zone = undefined){
        object.setInteractive({useHandCursor: true});
        object.dragId = id;

        this.scene.input.setDraggable(object);
        this.draggableGroup.add(object);

        if (zone) {
            this.drop(undefined, object, zone)
        }
    }

    addDropZone(object, id, gameObject = undefined){
        object.setInteractive({dropZone: true});
        object.dragId = id;
        this.dropZoneGroup.add(object);

        object.dropped = gameObject;
        if (gameObject) {
            this.drop(undefined, gameObject, object)
        }

    }

    // -- Fonctions à modifier dans les enfants ou le jeu
    // Fonctionnement par defaut : les éléments sont positionnés sur les zones. Quand on place un élément, l'ancien se déplace sur la zone du nouveau.

    drop(pointer, gameObject, dropZone){
        // On déplace l'élément déjà présent vers l'ancienne dropzone
        var oldDropZone = gameObject.dropedZone
        var oldDropped = dropZone.dropped

        if(oldDropZone && oldDropped){
            oldDropZone.dropped = oldDropped
            oldDropped.dropedZone = oldDropZone

            this.scene.tweens.add({
                targets: oldDropped,
                duration: 300,
                x:oldDropZone.x,
                y:oldDropZone.y
            })
            oldDropped.depth = 1
        }else if(oldDropZone && !oldDropped){
            oldDropZone.dropped = undefined
        }
        
        // Positionne l'élément au centre de la zone
        gameObject.x = dropZone.x;
        gameObject.y = dropZone.y;
        gameObject.depth = 1

        // Modif info de la zone
        gameObject.dropedZone = dropZone;
        dropZone.dropped = gameObject;

        if(!this.allowRedrag){
            gameObject.input.enabled = false;
        }

        this.dropFunction(gameObject, dropZone)
    }

    dragEnd(pointer, gameObject, dropped){
        if (!dropped && !this.freeDrag)
        {
            if(gameObject.resetPosition){
                gameObject.resetPosition()
            }else{
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
        }
    }

    checkAnswer(){
        var correct = true;
        this.dropZoneGroup.getChildren().forEach(dropZone => {
            if(dropZone.dragId == dropZone.dropped.dragId){
                this.setTrue(dropZone);
            }else{
                correct = false;
                this.setFalse(dropZone)
            }
        });

        return correct
    }

    restart(){
        this.dropZoneGroup.getChildren().forEach(dropZone => {
            this.setNormal(dropZone);
        });
    }

    restartFalse(){
        this.dropZoneGroup.getChildren().forEach(dropZone => {
            if(dropZone.dragId != dropZone.dropped.dragId){
                this.setNormal(dropZone);
            }
        });
    }

    setTrue(dropZone){
        // Modif de la réponse
        var dropped = dropZone.dropped
        dropped.input.enabled = false;
        dropped.setTrue();

        // Modif question
        dropZone.fondQ.setFrame(1);

    }

    setFalse(dropZone){
        // Modif de la réponse
        var dropped = dropZone.dropped
        dropped.setFalse();
        
        // Modif question
        dropZone.fondQ.setFrame(2);
    }

    setNormal(dropZone){
        // Modif de la réponse
        var dropped = dropZone.dropped
        dropped.setNormal();
        
        // Modif question
        dropZone.fondQ.setFrame(0);
    }

    getDropZoneById(id){
        var drop = undefined
        this.dropZoneGroup.getChildren().forEach(dropZone => {
            if(dropZone.id == id){
                drop = dropZone;
            }
        });
        return drop
    }

    setOnDropFunc(func){
        this.dropFunction = func;
    }

}